"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429.77 257.86",
    fill: "currentColor",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M514.48,405.07,467.7,271.41A21.5,21.5,0,0,0,447.42,257H421.77a7.16,7.16,0,0,0-7.16,7.17v71.62H400.28v-43A35.86,35.86,0,0,0,364.47,257H298L274,186.65a21.58,21.58,0,0,0-20.66-15.58H178.23c-.18,0-.35,0-.53,0H92.54l-.27,0a7.16,7.16,0,0,0,0,14.31h38.48l122.63,0a7.33,7.33,0,0,1,7,5.54l28.95,80.42h75.15A21.51,21.51,0,0,1,386,292.84v43H314.33a28.65,28.65,0,1,0,0,57.3h62.42a49.73,49.73,0,0,1-40.94,21.5H149.58a50.14,50.14,0,0,1,0-100.28h116.1a7.17,7.17,0,0,0,0-14.33H149.58a64.35,64.35,0,0,0-50.14,24V271.36a7.16,7.16,0,1,0-14.31,0v93.11a64.54,64.54,0,0,0,64.46,64.46H335.81a64,64,0,0,0,57.48-35.81h21.32a21.51,21.51,0,0,0,21.48,21.49h71.63a7.17,7.17,0,0,0,6.76-9.54Zm-78.39-4.79a7.17,7.17,0,0,1-7.16-7.16V386a7.17,7.17,0,0,0-7.16-7.16H314.33a14.33,14.33,0,1,1,0-28.65H421.77a7.17,7.17,0,0,0,7.16-7.16V271.35h18.49a7.17,7.17,0,0,1,6.76,4.8l43.45,124.13Z",
      transform: "translate(-85.12 -171.07)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M235.53,328.65a35.82,35.82,0,1,0,35.82,35.82A35.86,35.86,0,0,0,235.53,328.65Zm0,57.3A21.49,21.49,0,1,1,257,364.47,21.5,21.5,0,0,1,235.53,386Z",
      transform: "translate(-85.12 -171.07)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M113.77,364.47a35.81,35.81,0,1,0,35.81-35.82A35.85,35.85,0,0,0,113.77,364.47Zm57.3,0A21.49,21.49,0,1,1,149.58,343,21.51,21.51,0,0,1,171.07,364.47Z",
      transform: "translate(-85.12 -171.07)"
    })]
  });
};

exports.default = Icon;